<template>
  <!-- 客户车辆详情 -->
  <div class="container">
    <!--  车辆联系人卡片  -->
    <div class="car-info-card car-info-card1">
      <div class="card-carinfo">
        <div class="card-carinfo-header">
          <div class="card-carinfo-title">
            <span>{{ carInfo.plate_number | text }}</span>
            <span v-if="carInStore" class="tag">在店</span>
          </div>
          <img
            class="card-carinfo-btn"
            src="./imgs/switch.svg"
            alt=""
            @click="handleSwitchCar"
          />
        </div>
        <div class="card-carinfo-desc">
          <span>{{ carInfo.vin | text }}</span>
          <span v-if="carInfo.model_desc"> | {{ carInfo.model_desc }}</span>
        </div>
      </div>
      <CarBusinessDynamic :plateNumber="carInfo.plate_number" :vin="carInfo.vin" />
      <CarScheduleDynamic :plateNumber="carInfo.plate_number" :vin="carInfo.vin" :serviceConsultantName="carInfo.service_consultant_name" />
    </div>

    <div class="car-info-card car-info-service-personnel">
      <ServicePersonnel :baseCarId="carId" />
      <CarContacts :contacts="carInfo.contacts" @change-current-contact="handleChangeCurrentContact" />
    </div>

    <div class="car-info-card car-info-card2">
      <!--  定保续保tab  -->
      <tab class="car-info-tab" default-color="#989EA9" active-color='#217BFF' v-if="hasInsAuth">
        <tab-item v-for="(item, key) in tabs"
                  :key="key" :selected="item === activeTab"
                  @on-item-click="activeTab = item"
        >{{ item }}
        </tab-item>
      </tab>

      <!--   定保   -->
      <template v-if="activeTab === '定保'">
        <view-regular-maintenance :solicit-info="solicitInfo" />
      </template>
      <!--   续保   -->
      <template v-if="activeTab === '续保'">
        <view-renew-insurance :ins-info="insInfo" />
      </template>
      <!--   增项   -->
      <template v-if="activeTab === '增项'">
        <view-addition-item :addition-info="additionInfo" />
      </template>
      <!--   卡券   -->
      <template v-if="activeTab === '卡券'">
        <view-coupon-info :coupons-info="couponInfo" />
      </template>
    </div>
    <div class="car-info-placeholder"></div>

    <Confirm ref="confirm" />
    <!-- 建群 -->
    <CreateServiceGroupDialog ref="createServiceGroupDialog" />

    <div v-if="isNotBindServiceGroup" class="float-btn">
      <x-button
        type="primary"
        @click="handleOpenCreateServiceGroupDialog"
      >一键建群</x-button>
    </div>
  </div>
</template>

<script>
import ViewAdditionItem from '@/modules/aftersales/components/infoTabs/viewAdditionItem.vue'
import ViewCouponInfo from '@/modules/aftersales/components/infoTabs/viewCouponInfo.vue'
import ViewRegularMaintenance from '@/modules/aftersales/components/infoTabs/viewRegularMaintenance.vue'
import ViewRenewInsurance from '@/modules/aftersales/components/infoTabs/viewRenewInsurance.vue'
import { Tab, TabItem, XButton } from '@lx-frontend/cvux'
import CarBusinessDynamic from './components/CarBusinessDynamic.vue'
import CarScheduleDynamic from './components/CarScheduleDynamic.vue'
import CarContacts from './components/CarContacts.vue'
import ServicePersonnel from './components/ServicePersonnel.vue'
import Confirm from '@/components/Confirm/Index.vue'
import CreateServiceGroupDialog from './components/CreateServiceGroupDialog.vue'

import mixin from './mixins/index.mixin'
import { traceEventsReport } from '../../common/report'
import util from '../../common/util'

export default {
  mixins: [mixin],
  components: {
    ViewCouponInfo,
    ViewAdditionItem,
    ViewRenewInsurance,
    ViewRegularMaintenance,
    Tab,
    TabItem,
    XButton,
    CarBusinessDynamic,
    CarScheduleDynamic,
    CarContacts,
    ServicePersonnel,
    Confirm,
    CreateServiceGroupDialog
  },
  data() {
    return {
      activeTab: '定保',
      tabs: ['定保', '续保', '增项', '卡券'],
      hasInsAuth: false,
      carInfo: {
        contacts: [],
        solicit_info: {
          customer_tag_names: [],
          last_follow_record: {}
        },
        ins_info: {}
      },
      carInStore: false,
      /** 是否从列表页进入 */
      isFromListPage: false,
      additionInfo: null,
      couponInfo: {
        details: [],
        stats: {
          total_coupon_packages: 0,
          total_coupons: 0,
          total_gift_cards: 0
        }
      },
      chatId: '',
      entranceEnv: ''
    }
  },
  computed: {
    hasMobileType() {
      const deviceType = util.getDeviceType()
      const dict = {
        'Mac OS': 1,
        'Windows': 1,
        'Android': 2,
        'IOS': 2,
        'unknown': 0
      }
      return dict[deviceType] === 2
    },
    carId() {
      return Number(this.$route.query.carId)
    },
    userMobile() {
      return this.$route.query.mobile
    },
    // // 用户名下有多辆车
    // hasMultiCar() {
    //   return this.carList.length > 1
    // },
    // 定保信息
    solicitInfo() {
      return this.carInfo.solicit_info || {}
    },
    //  续保信息
    insInfo() {
      return this.carInfo.ins_info || {}
    },
    isNotBindServiceGroup() {
      return !this.chatId && !this.userInfo.chatid
    }
  },
  methods: {
    // 是否可以拨打电话
    // 1.移动端 2.手机号合法
    hasCallMobile(mobileNumber) {
      return this.hasMobileType && util.regexpMap.regexp_mobile.test(mobileNumber)
    },
    handleChangeCurrentContact(item) {
      this.$refs.confirm.open({
        content: `将 ${item.name} (${item.mobile_number}) 设置为当前联系人`,
        onConfirm: async() => {
          const params = { mobile_number: item.mobile_number, name: item.name }
          if (!(await this.updateExternalUserInfo(params))) return Promise.reject(new Error('操作失败'))
          this.handleChangeCurrentContactSuccess(item.mobile_number)
        }
      })
    },
    // 切换当前联系人成功，修改路由参数，刷新页面
    handleChangeCurrentContactSuccess(mobile) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          carId: this.carId,
          mobile: mobile
        }
      })
      this.$router.go(0)
    },

    handleOpenCreateServiceGroupDialog() {
      this.$refs.createServiceGroupDialog.open({ ...this.userInfo, ...this.carInfo })
    },
    async getCarInfo() {
      this.switchLoading({ status: true, text: '加载中...' })
      const { code, message, data } = await this.$rest.aftersales.getCarInfo(this.carId)({
        mobile_number: this.userMobile
      })
      this.switchLoading({})
      if (code !== 0) {
        this.$cvux.toast.show({ type: 'text', width: '', text: message })
        return
      }
      // 是否有续保权限
      this.hasInsAuth = Boolean(data.ins_info) // ins_info 返回null即表示无续保权限
      this.additionInfo = data.em_addition_info
      this.couponInfo = data.coupons_info
      this.setDefaultInfo(data)
      this.getCarInSotre()
    },
    setDefaultInfo(data) {
      const result = { ...data }
      // 联系人排序
      const unwatch = this.$watch(() => this.userInfo, () => {
        if (!Object.keys(this.userInfo).length) {
          return
        }
        result.contacts = result.contacts.reduce((total, current) => {
          current.id === this.userInfo.id ? total.unshift(current) : total.push(current)
          return total
        }, [])
        unwatch && unwatch()
      }, { immediate: true })

      if (!result.solicit_info || !Object.keys(result.solicit_info).length) {
        result.solicit_info = {
          customer_tag_names: [],
          last_follow_record: {}
        }
      }
      if (!result.ins_info || !Object.keys(result.ins_info).length) {
        result.ins_info = {
          last_follow: {},
          policy_type: {}
        }
      }
      this.carInfo = result
    },
    async pageInitTrace(pageId) {
      //  车辆详情页渲染成功上报埋点数据
      const traceFields = await this.getCommonTraceFields()
      traceEventsReport('2-2-3-0-0-0', [{
        ...traceFields,
        page_id: pageId
      }])
    },
    async getCarInSotre() {
      const { code, data } = await this.$rest.aftersales.getCarStatus({ plate_number: encodeURIComponent(this.carInfo.plate_number) })
      if (code) return
      this.carInStore = data.in_store
    },
    handleSwitchCar() {
      if (this.isFromListPage) {
        this.$router.back()
      } else {
        this.$router.push({ path: '/aftersales/carList' })
      }
    },
    getChatId() {
      return this.$wechat.promise.then(async wx => {
        // 获取应用入口环境
        this.entranceEnv = await wx.getEntranceEnv()
        // 从群聊环境进入应用
        if (this.entranceEnv !== 'group_chat_tools') return
        this.chatId = await wx.getCurExternalChat()
      })
    },
    async setDefaultCarId() {
      if (!this.carId) return
      if (this.userInfo.default_car_id === this.carId) return
      const wx = await this.$wechat.promise
      const externalUserId = await wx.getCurExternalUserId()
      const { code } = await this.$rest.aftersales.updateCustomerDefaultCar({ external_userid: externalUserId, default_car_id: this.carId })
      if (code) return
      this.$store.commit('aftersales/UPDATE_USER_DEFAULT_CAR_ID', this.carId)
    }
  },
  async created() {
    this.getCarInfo()
    this.getChatId()
    await this.getInitData()
    this.setDefaultCarId()
  },
  mounted() {
    //  车辆详情页渲染成功上报埋点数据
    this.$nextTick(() => this.pageInitTrace(this.sourcePage))
  },
  filters: {
    text(val) {
      return val || '--'
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.isFromListPage = from.name === 'aftersalesCarList'
    })
  }
}
</script>

<style lang="less" scoped>
@import '../../stylesheets/modules/aftersales/carInfo.less';

@w2: 75rem;
.container {
  padding: 20/@w2;

  .car-info-tag {
    background: #ECF4FF;
    border: #3975C6 1px solid;
    color: #3975C6;
    border-radius: 4/@w2;
    text-align: center;
    display: inline-block;
  }

  .car-info-card {
    background: #fff;
    border-radius: 16/@w2;
    margin-bottom: 20/@w2;
  }

  .car-info-user {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
  }

  .car-info-card1 {
    padding: 30/@w2;
    display: grid;
    grid-template-rows: 1fr;
    gap: 20/@w2;

    .card-carinfo {
      position: relative;
      overflow: hidden;

      .card-carinfo-header {
        display: flex;
        align-items: center;
      }

      .card-carinfo-title {
        font-size: 40/@w2;
        font-weight: bold;
        color: #1F2023;
        line-height: 56/@w2;
        display: flex;
        align-items: center;
        gap: 10/@w2;
        flex: 1;
      }

      .card-carinfo-desc {
        font-size: 26/@w2;
        color: #989EA9;
        line-height: 36/@w2;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .card-carinfo-btn {
        width: 18px;
        height: 18px;
        cursor: pointer;
        user-select: none;
      }
    }

    .card-info-column-text {
      margin-top: 30/@w2;
      color: #1F2023;
      font-size: 30/@w2;
      line-height: 36/@w2;
      display: flex;

      .card-info-column-label {
        min-width: 150/@w2;
      }
    }

    .car-info-users {
      background: #F8FAFC;
      border-radius: 16/@w2;
      padding: 0 30/@w2 30/@w2;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 30/@w2;

      .car-info-user, .car-info-divider {
        margin-top: 30/@w2;
      }

      .car-info-user-name {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 28/@w2;

        .car-info-tag {
          //width: 100/@w2;
          height: 32/@w2;
          line-height: 32/@w2;
          margin-left: 20/@w2;
          font-size: 20/@w2;
          padding: 0 6/@w2;
        }
      }

      .car-info-user-phone {
        color: #3975C6;
        font-size: 30/@w2;
        line-height: 30/@w2;
      }

      .car-info-user-phone-disabled {
        color: #989EA9;
      }
    }
  }

  .car-info-card2 {
    padding: 0 30/@w2 30/@w2;
    margin-bottom: 0;

    .car-info-tab {
      height: 100/@w2;

      .vux-tab-item {
        height: 100/@w2;
        line-height: 100/@w2;
        font-size: 32/@w2;

        &.vux-tab-selected {
          font-weight: bold;
        }
      }
    }
  }

  .car-info-service-personnel {
    padding: 30/@w2;
  }

  .car-info-placeholder {
    height: 20/@w2;
  }

  .float-btn {
    position: fixed;
    bottom: 40/@w2;
    left: 50%;
    transform: translateX(-50%);
    z-index: 500;

    /deep/ .weui_btn {
      width: 240/@w2;
      height: 80/@w2;
      font-size: 30/@w2;
      border-radius: 40/@w2;
    }
  }
}
</style>
